'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChatbubbleQuestionFill from '@common/icon/SvgChatbubbleQuestionFill';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES, PARTNER_SUB_DOMAIN_LIST } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { DONATION_DESKTOP_HEADER_HEIGHT, DONATION_SUB_HEADER_HEIGHT } from '../../constants';
import { Agencies } from './Agencies';
import { RegionFinderDropdown } from './RegionFinderDropdown';
export const DonationSubHeader = () => {
  const $ = _c(30);
  const partnerChromeClassName = usePartnerChromeClassName();
  const pathname = usePathname();
  const isKakaobank = useCheckKakaobank();
  const isPartnerChannel = useDeviceInfoStore(_temp);
  let t0;
  if ($[0] !== partnerChromeClassName) {
    t0 = cn(partnerChromeClassName, "sticky z-10 w-full bg-Gray-white mobile:hidden tablet:hidden");
    $[0] = partnerChromeClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: DONATION_DESKTOP_HEADER_HEIGHT,
      height: DONATION_SUB_HEADER_HEIGHT
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li><RegionFinderDropdown /></li>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = DONATION_ROUTES.GIFTS.pathname === pathname;
  let t4;
  if ($[4] !== t3) {
    t4 = <SubLink href={DONATION_ROUTES.GIFTS.pathname} isSelected={t3}>답례품</SubLink>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname === pathname;
  let t6;
  if ($[6] !== t5) {
    t6 = <SubLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname} isSelected={t5}>지정기부사업</SubLink>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = DONATION_ROUTES.MY_ETC_EVENT.pathname === pathname;
  let t8;
  if ($[8] !== t7) {
    t8 = <SubLink href={DONATION_ROUTES.MY_ETC_EVENT.pathname} isSelected={t7}>이벤트</SubLink>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isPartnerChannel || $[11] !== pathname) {
    t9 = isPartnerChannel ? null : <SubLink href={DONATION_ROUTES.GIFT_TRIAL.pathname} isSelected={DONATION_ROUTES.GIFT_TRIAL.pathname === pathname}>답례품 체험단</SubLink>;
    $[10] = isPartnerChannel;
    $[11] = pathname;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = DONATION_ROUTES.GUIDE.pathname === pathname;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SvgChatbubbleQuestionFill className="ml-4 size-16 text-B-500" />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10) {
    t12 = <SubLink href={DONATION_ROUTES.GUIDE.pathname} isSelected={t10}>고향사랑기부 안내{t11}</SubLink>;
    $[14] = t10;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8 || $[20] !== t9) {
    t13 = <ul className="flex items-center gap-12">{t2}<li className="flex items-center">{t4}{t6}{t8}{t9}{t12}</li></ul>;
    $[16] = t12;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isKakaobank) {
    t14 = !isKakaobank && <Agencies />;
    $[22] = isKakaobank;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = <nav className="mx-auto flex h-full max-w-screen-xl items-center justify-between px-40">{t13}{t14}</nav>;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t0 || $[28] !== t15) {
    t16 = <div className={t0} style={t1}>{t15}</div>;
    $[27] = t0;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
const SubLink = t0 => {
  const $ = _c(7);
  const {
    href,
    isSelected,
    children
  } = t0;
  const t1 = isSelected ? "page" : undefined;
  const t2 = isSelected ? "font-700 text-Gray-800" : "font-600 text-Gray-700 hover:text-Gray-900";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex h-56 items-center px-24 transition-colors typo-body3", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== href || $[4] !== t1 || $[5] !== t3) {
    t4 = <CustomLink href={href} aria-current={t1} className={t3}>{children}</CustomLink>;
    $[2] = children;
    $[3] = href;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(state) {
  return PARTNER_SUB_DOMAIN_LIST.some(partner => partner === state.subDomain);
}